import parseFilters from '@utils/parseFiltersIndicators'
import parseLcmFilters from '@utils/parseLcmFilters'
import RestApiBuilder from '@utils/RestApiBuilder'
import { ApisauceInstance } from 'apisauce'
import useClientConfig from 'config/clients/useClientConfig'

const parseExtraFilters = (extras: any) => {
  return extras
    ? Object.keys(extras)
      .filter((key) => key !== 'criticalMomentId')
      .reduce((obj, key) => {
        const value = extras[key]
        if (value !== undefined && value !== null) {
          return Object.assign(obj, { [key]: value, })
        }

        return obj
      }, {})
    : extras
}

/**
 * Expose all endponts for 'reports'.
 */
export default <T>(vocApi: ApisauceInstance, lcmApi: ApisauceInstance): ApiObject => ({
  ...RestApiBuilder<T>('indicators', vocApi),
  data: (url: string, filters: any, filtersData: Record<string, any>, extras: any) => {
    const useLcmApi = extras !== undefined
      && extras.useLcmApi !== undefined
      && extras.useLcmApi

    if (useLcmApi) {
      return lcmApi.get(url, {
        ...parseLcmFilters(filters, filtersData, extras)
      })
    }

    return vocApi.post(url, {
      ...parseFilters(filters, extras),
      ...parseExtraFilters(extras),
    })
  },
  comments: (tag: string, filters: FiltersUI, extras: any) => {
    const { getSentimentCommentsIndicatorName } = useClientConfig()
    //console.log('API get comments')
    //console.log(extras)
    return vocApi.post('indicators/' + getSentimentCommentsIndicatorName() + '/values', {
      ...parseFilters(filters, extras),
      ...parseExtraFilters(extras),
      tag,
    })
  },
})
